// Status "open voor oplevering" per post (SPEC 27okt 4). Los bestand zodat types.ts en
// extraRegels.ts het schema kunnen gebruiken zonder kringverwijzing.
import { z } from 'zod';

export const opleveringStatusSchema = z.enum(['factureerbaar', 'open']);
export type OpleveringStatus = z.infer<typeof opleveringStatusSchema>;

export const opleveringSchema = z.object({
  status: opleveringStatusSchema,
  /** Optioneel: verwachte opleverdatum (YYYY-MM-DD). */
  verwachteDatum: z.string().nullable().optional(),
  opmerking: z.string().optional(),
  gezetDoor: z.string().nullable().optional(),
  gezetOp: z.string().nullable().optional(),
  /** Vrijgave (open → factureerbaar): enkel Eranda, Timen of Ervin, met datum en log. */
  vrijgegevenDoor: z.string().nullable().optional(),
  vrijgegevenOp: z.string().nullable().optional(),
});
export type Oplevering = z.infer<typeof opleveringSchema>;

export function isOpen(o: { oplevering?: Oplevering | null } | null | undefined): boolean {
  return o?.oplevering?.status === 'open';
}
